import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { cookie, generateUUID } from '@blue/services/utils';
import { getAppConfig } from '@blue/app-info';

import * as ɵngcc0 from '@angular/core';
class BrowserInfo {
    constructor() {
    }
}
class UkHmrcFraudPreventionService {
    constructor() {
        var _a;
        let appConfig = null;
        try {
            appConfig = getAppConfig();
        }
        catch (_b) {
            appConfig = null;
        }
        this.verticalName = appConfig === null || appConfig === void 0 ? void 0 : appConfig.verticalName;
        this.version = (_a = appConfig === null || appConfig === void 0 ? void 0 : appConfig.version) !== null && _a !== void 0 ? _a : '0.0.0.0';
    }
    init() {
        // this doesn't do anything, but is called from the component to
        // ensure this service is created when bootstrapping in angularjs
    }
    addHeaders(headers) {
        return this.getHeaders().then((httpHeaders) => {
            headers = headers || [];
            httpHeaders.keys().forEach(key => {
                headers[key] = httpHeaders.getAll(key);
            });
            return headers;
        });
    }
    getHeaders() {
        return this.buildBrowserClientInfo().then((browserInfo) => {
            let headers = new HttpHeaders();
            headers = headers.append('Gov-Client-Connection-Method', 'WEB_APP_VIA_SERVER');
            if (this.verticalName) {
                headers = headers.append('Gov-Vendor-Version', `${this.verticalName}=${this.version}`);
            }
            headers = headers.append('Gov-Client-Timezone', browserInfo.timezoneOffset);
            headers = headers.append('Gov-Client-Screens', browserInfo.screenInfo);
            headers = headers.append('Gov-Client-Window-Size', browserInfo.windowSize);
            headers = headers.append('Gov-Client-Browser-JS-User-Agent', browserInfo.userAgent);
            headers = headers.append('Gov-Client-Browser-Do-Not-Track', browserInfo.doNotTrack ? 'true' : 'false');
            headers = headers.append('Gov-Client-Device-ID', this.getClientDeviceId());
            return headers;
        });
    }
    buildBrowserClientInfo() {
        const browserInfo = new BrowserInfo();
        browserInfo.userAgent = navigator.userAgent;
        browserInfo.doNotTrack = this.getDoNotTrack();
        browserInfo.screenInfo = this.getScreenInfo();
        browserInfo.windowSize = this.getWindowSize();
        browserInfo.timezoneOffset = this.getTimeZone();
        return Promise.resolve(browserInfo);
    }
    getClientDeviceId() {
        const cookieName = 'hmrc-client-device-id';
        let clientDeviceId = cookie(cookieName);
        if (!clientDeviceId) {
            clientDeviceId = generateUUID();
            cookie(cookieName, clientDeviceId);
        }
        return clientDeviceId;
    }
    getScreenInfo() {
        // make sure the width and height are at least 1 else if will fail HMRC validation
        let screenInfo = 'width=' + Math.max(screen.width, 1) + '&height=' + Math.max(screen.height, 1);
        screenInfo += '&scaling-factor=' + window.devicePixelRatio;
        screenInfo += '&colour-depth=' + screen.colorDepth;
        return screenInfo;
    }
    getWindowSize() {
        // make sure the width and height are at least 1 else if will fail HMRC validation
        const windowSize = 'width=' + Math.max(window.innerWidth, 1) + '&height=' + Math.max(window.innerHeight, 1);
        return windowSize;
    }
    getDoNotTrack() {
        const nav = navigator;
        const anyWindow = window;
        try {
            if (anyWindow.doNotTrack || nav.doNotTrack || nav.msDoNotTrack) {
                // the browser supports Do Not Track, so get state
                if (anyWindow.doNotTrack === '1' || nav.doNotTrack === 'yes' ||
                    nav.doNotTrack === '1' || nav.msDoNotTrack === '1') {
                    // Do Not Track is enabled
                    return true;
                }
                else {
                    // Do Not Track is disabled
                    return false;
                }
            }
        }
        catch (e) {
            console.log('Unable to determine do-not-track setting', e);
        }
        // Do Not Track is not supported
        return undefined;
    }
    getTimeZone() {
        const offset = new Date().getTimezoneOffset();
        const o = Math.abs(offset);
        return 'UTC' + (offset <= 0 ? '+' : '-') + ('00' + Math.floor(o / 60)).slice(-2) + ':' + ('00' + (o % 60)).slice(-2);
    }
}
UkHmrcFraudPreventionService.ɵfac = function UkHmrcFraudPreventionService_Factory(t) { return new (t || UkHmrcFraudPreventionService)(); };
UkHmrcFraudPreventionService.ɵprov = i0.ɵɵdefineInjectable({ factory: function UkHmrcFraudPreventionService_Factory() { return new UkHmrcFraudPreventionService(); }, token: UkHmrcFraudPreventionService, providedIn: "root" });
UkHmrcFraudPreventionService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkHmrcFraudPreventionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class UkHmrcFraudPreventionComponent {
    constructor(ukHmrcFraudPreventionService) {
        // not used in here, but pulled in to make sure it gets created when bootstrapping the component in angularjs
        ukHmrcFraudPreventionService.init();
    }
    ngOnInit() {
    }
}
UkHmrcFraudPreventionComponent.ɵfac = function UkHmrcFraudPreventionComponent_Factory(t) { return new (t || UkHmrcFraudPreventionComponent)(ɵngcc0.ɵɵdirectiveInject(UkHmrcFraudPreventionService)); };
UkHmrcFraudPreventionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UkHmrcFraudPreventionComponent, selectors: [["uk-hmrc-fraud-prevention"]], decls: 0, vars: 0, template: function UkHmrcFraudPreventionComponent_Template(rf, ctx) { }, encapsulation: 2 });
UkHmrcFraudPreventionComponent.ctorParameters = () => [
    { type: UkHmrcFraudPreventionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkHmrcFraudPreventionComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'uk-hmrc-fraud-prevention',
                template: ``
            }]
    }], function () { return [{ type: UkHmrcFraudPreventionService }]; }, null); })();

class UkHmrcFraudPreventionModule {
}
UkHmrcFraudPreventionModule.ɵfac = function UkHmrcFraudPreventionModule_Factory(t) { return new (t || UkHmrcFraudPreventionModule)(); };
UkHmrcFraudPreventionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UkHmrcFraudPreventionModule });
UkHmrcFraudPreventionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        UkHmrcFraudPreventionService,
    ], imports: [[ // Modules needed by this module
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkHmrcFraudPreventionModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    UkHmrcFraudPreventionComponent,
                ],
                imports: [ // Modules needed by this module
                ],
                exports: [ // Components exported by this module
                ],
                providers: [
                    UkHmrcFraudPreventionService,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UkHmrcFraudPreventionModule, { declarations: [UkHmrcFraudPreventionComponent] }); })();

/*
 * Public API Surface of uk-hmrc-fraud-prevention
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UkHmrcFraudPreventionComponent, UkHmrcFraudPreventionModule, UkHmrcFraudPreventionService };

